<form [formGroup]="form" (ngSubmit)="submit()" #content>
	<div class="modal-dialog edit-transcription-speakers-dialog-container">
		<div class="modal-content" cdkTrapFocus goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
			<div class="goreact-modal-header">
				<h4 class="modal-title" translate="edit-transcription-speakers_title" [id]="dialogTitleId"></h4>
				<button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
					<i class="ficon-app-x"></i>
				</button>
			</div>
			<div class="goreact-modal-body">
				@for (speaker of data.speakers; track speaker) {
					<mat-form-field appearance="outline">
						<mat-label>
							{{ 'edit-transcription-speakers_label' | translate | uppercase }}
						</mat-label>
						<input type="text" matInput [formControlName]="speaker" maxlength="25" [class]="speaker"/>
						@if (form.get(speaker).hasError('required')) {
							<mat-error>
								{{ 'edit-transcription-speakers_required' | translate }}
							</mat-error>
						}
					</mat-form-field>
				}
			</div>
			<div class="goreact-modal-footer">
				<button class="cancel-button tertiary-btn" (click)="cancel()" translate="common_cancel"></button>
				<button class="confirm-button primary-btn"
					type="submit"
					[disabled]="submitting$ | async"
					[focusOnFirstInvalidField]="{ formGroup: form, formWrapper: content }">
					{{
						((submitting$ | async) ?
							'feedback-session_controller-saving' :
							'common_save') | translate
					}}
				</button>
			</div>
		</div>
	</div>
</form>
